module.exports = __webpack_public_path__ + "media/images/login---ea5ae788.jpg";